<fe-header style="z-index: 10000"></fe-header>
<main class="mb-26 mb-sm-20">
    <section class="container-fluid">
        <div class="container-xl">
            <div class="content">
                <div class="content__top pt-4 pt-lmd-5 mb-3 mb-lmd-4">
                    <div
                        class="d-flex flex-row justify-content-between align-items-center"
                    >
                        <h2>
                            {{ 'fe_categories_services_top_title' | translate }}
                        </h2>
                        <fe-button
                            [href]="'' | formatUrl"
                            [fragment]="'doReservation'"
                            class="d-none d-lmd-flex"
                            [style]="'tertiary'"
                        >
                            <p>
                                {{
                                    'fe_categories_services_top_button'
                                        | translate
                                }}
                            </p>
                        </fe-button>
                    </div>
                    <a
                        [href]="'#doReservation' | formatUrl"
                        class="d-flex d-lmd-none justify-content-center mt-3 py-3"
                        >{{
                            'fe_categories_services_top_button' | translate
                        }}</a
                    >
                </div>
                <div class="content__bottom">
                    <div class="row">
                        <div class="col-12 col-lmd-3">
                            <div class="content__bottom__left">
                                <div class="content__bottom__left__title p-3">
                                    <h4>
                                        {{
                                            'fe_categories_services_bottom_left_title'
                                                | translate
                                        }}
                                    </h4>
                                </div>
                                <div
                                    class="content__bottom__left__checkboxes px-4 py-2"
                                >
                                    <legend class="mb-2">
                                        {{
                                            'fe_categories_services_bottom_left_checkboxes_legend'
                                                | translate
                                        }}
                                    </legend>
                                    <ng-container *ngIf="cars?.data?.category">
                                        <div
                                            *ngFor="
                                                let category of cars!.data!
                                                    .category
                                            "
                                            class="form-check d-flex flex-row align-items-center mb-1"
                                        >
                                            <input
                                                class="form-check-input my-0 me-2"
                                                type="checkbox"
                                                [value]="category.type"
                                                [id]="category.type"
                                                (change)="
                                                    onFilterChange(
                                                        $event,
                                                        category.type
                                                    )
                                                "
                                            />
                                            <label
                                                class="form-check-label"
                                                [for]="category.type"
                                            >
                                                {{
                                                    'fe_categories_services_bottom_left_checkboxes_label_' +
                                                        category.type
                                                        | translate
                                                }}
                                            </label>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-lmd-9">
                            <div class="content__bottom__right">
                                <div class="content__bottom__right__title py-3">
                                    <h3>
                                        {{
                                            'fe_categories_services_bottom_right_title'
                                                | translate
                                        }}
                                    </h3>
                                </div>
                                <div class="content__bottom__right__cards">
                                    <div class="row">
                                        <ng-container *ngIf="filteredCars">
                                            <div
                                                *ngFor="let car of filteredCars"
                                                class="col-12 col-sm-6 col-lmd-4 my-4"
                                            >
                                                <div
                                                    class="content__bottom__right__cards__inside p-4 flex-fill d-flex flex-column align-items-center"
                                                >
                                                    <h3>{{ car.title }}</h3>
                                                    <p class="py-1">
                                                        {{ car.model }}
                                                    </p>
                                                    <div
                                                        class="content__bottom__right__cards__inside__third d-flex flex-row align-items-center align-self-center justify-content-center pb-4"
                                                    >
                                                        <img
                                                            class="svgs"
                                                            [src]="
                                                                car.transmission ===
                                                                'AT'
                                                                    ? ('images/icon-trans-aut.svg'
                                                                      | cdn)
                                                                    : ('images/transmission.svg'
                                                                      | cdn)
                                                            "
                                                            alt="transmission"
                                                        />
                                                        <p class="ps-2">
                                                            {{
                                                                car.transmission ===
                                                                'AT'
                                                                    ? ('fe_categories_services_bottom_right_transmission_at'
                                                                      | translate)
                                                                    : ('fe_categories_services_bottom_right_transmission_sd'
                                                                      | translate)
                                                            }}
                                                        </p>
                                                        <div class="mx-2"></div>
                                                        <img
                                                            class="svgs"
                                                            [src]="
                                                                'images/icon-seating.svg'
                                                                    | cdn
                                                            "
                                                            alt="passengers quantity"
                                                        />
                                                        <p class="ps-2">
                                                            {{ car.passenger }}
                                                        </p>
                                                        <div class="mx-2"></div>
                                                        <img
                                                            class="svgs"
                                                            [src]="
                                                                'images/icon-bag.svg'
                                                                    | cdn
                                                            "
                                                            alt="baggage"
                                                        />
                                                        <p class="ps-2">
                                                            {{ car.baggage }}
                                                        </p>
                                                    </div>
                                                    <img
                                                        class="car align-self-center"
                                                        [src]="
                                                            'images/' +
                                                                car.image | cdn
                                                        "
                                                        [alt]="car.model"
                                                    />
                                                </div>
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</main>
<fe-footer></fe-footer>
